<script setup lang="ts">
import type { Lead } from "@/model/app/lead"
import { ScEdit } from "@/sales/components/crud"
import { useLoadEntity, VfFormRow } from "@/vf"
import { createModuleConfiguration } from "./leads.config"

const props = defineProps<{ id?: string }>()
const config = createModuleConfiguration()
const { item } = await useLoadEntity<Lead>(props.id, config)
</script>

<template>
    <ScEdit v-bind="{ config, item }">
        <div class="grid grid-cols-2 gap-5">
            <VfFormRow name="salutation" />
            <VfFormRow name="title" />
        </div>

        <div class="grid grid-cols-2 gap-5">
            <VfFormRow name="firstName" />
            <VfFormRow name="lastName" />
        </div>

        <VfFormRow name="company" />

        <VfFormRow name="birthdate" />
        <VfFormRow name="street" />

        <div class="grid grid-cols-2 gap-5">
            <VfFormRow name="zipCode" />
            <VfFormRow name="city" />
        </div>
    </ScEdit>
</template>
